import React, { Component } from 'react';
import _ from 'underscore';
import { mixinsClassName, createElement } from '../utils';

export class Left extends Component {
    render() {
        return createElement.call(this, {
            className: "pull-left"
        });
    }
}

export class Right extends Component {
    render() {
        return createElement.call(this, {
            className: "pull-right"
        });
    }
}

export class Clearfix extends Component {
    render() {
        return createElement.call(this, {
            className: "clearfix"
        });
    }
}

export class CenterBlock extends Component {
    render() {
        return createElement.call(this, {
            className: "center-block text-center"
        });
    }
}

export class Topbar extends Component {
    render() {
        return createElement.call(this, {
            className: "ui-topbar"
        });
    }
}

export class Toolbar extends Component {
    render() {
        return createElement.call(this, {
            className: "ui-toolbar"
        });
    }
}

export class Footbar extends Component {
    render() {
        return createElement.call(this, {
            className: "ui-footbar"
        });
    }
}

export class Icon extends Component {
    render() {
        let { className, iconClass, tagName = 'i' } = this.props;
        let iconArr = (iconClass || '').split(" ");
        className = mixinsClassName("ui-icon icon", _.map(iconArr, (clz) => {
            return clz ? "icon-" + clz : "";
        }).join(" "), className);

        return React.createElement(tagName, { className })
    }
}

export class NoContent extends Component {
    render() {
        let { className, style = {}, text = '暂无内容' } = this.props;
        className = mixinsClassName("ui-no-content", className);

        return createElement.call(this, {
            className: className,
            style: style,
            beforeElement: <i className="icon icon-no-content"></i>,
            afterElement: <p>{text}</p>
        });
    }
}

export class Html extends Component {
    render() {
        const { className, value, useSafe } = this.props;
        let html = value;
        if (useSafe) {
            html = _.escape(value);
        }

        return <pre className={className} dangerouslySetInnerHTML={{__html: html}} />
    }
}


// WEBPACK FOOTER //
// ./src/ui/base.js